import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SettingsEffects } from './effects';
import { reducer, settingsFeatureKey } from './reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([SettingsEffects]),
    StoreModule.forFeature(settingsFeatureKey, reducer),
  ],
})
export class SettingsModule {}
